// noti.js
import { createApp, h } from 'vue';
import NotiTemp from '@/components/other/NotiTemp.vue';

// [중요] 전역 변수 하나로 관리하면 여러 알림이 동시에 뜰 때 unmount 에러가 날 수 있으므로
// 인스턴스를 각각의 스코프 내에서 독립적으로 관리하도록 변경합니다.

// 1. 단일 변수 호출형 noti
// 사용법: this.$noti("msg", "red", 6000)
const createNotiInstance = (msg, color, duration = 1500) => {
  const targetElement = document.body;

  const currentInstance = createApp({
    render: () => h(NotiTemp, { msg, color }),
  });

  const notiElement = document.createElement('div');
  currentInstance.mount(notiElement);
  targetElement.appendChild(notiElement);

  // 하드코딩된 1500 대신 넘어온 duration 값을 사용합니다.
  setTimeout(() => {
    currentInstance.unmount();
    notiElement.remove();
  }, duration);
};

// duration 파라미터를 추가로 받을 수 있게 확장
const noti = function(msg, color, duration) {
  createNotiInstance(msg, color, duration);
};


// 2. Object 입력형 noti
// 사용법: this.$noti2({ msg: "msg", color: "red", duration: 6000 })
const createNoti2Instance = (options) => {
  // 구조 분해 할당 시 duration이 없으면 기본값 1500 사용
  const { msg, color, duration = 1500 } = options;
  const targetElement = document.body;

  const currentInstance = createApp({
    render: () => h(NotiTemp, { msg, color }),
  });

  const notiElement = document.createElement('div');
  currentInstance.mount(notiElement);
  targetElement.appendChild(notiElement);

  setTimeout(() => {
    currentInstance.unmount();
    notiElement.remove();
  }, duration);
};

const noti2 = function(options) {
  createNoti2Instance(options);
};


export default {
  install(Vue) {
    Vue.config.globalProperties.$noti = noti;
    Vue.config.globalProperties.$noti2 = noti2;
  },
};